import React, { useMemo } from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing'
import NexposeCredentialsForm from './NexposeCredentialsForm'
import NexposeMappingForm from './NexposeMappingForm'
import { CellRenderers, columnRenderArrayData } from "utils/tableUtils";


export default function NexposeConfigListing(props) {
    const columns = useMemo(() => [
        {
            title: "Tags",
            dataIndex: "tagName",
            width: 240,
            render: columnRenderArrayData
        },
        {
            title: "Site",
            dataIndex: "siteName",
            width: 240,
            render: CellRenderers.VALUE_OR_NA
        }
    ], [])
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={NexposeMappingForm}
            CredentialsForm={NexposeCredentialsForm}
            extraColumns={columns}

        />
    )
}